export function fiatToCrypto(order: { rate: number; fee: number }, value: null | number): number {
  return (value ?? 0) * (order.rate * (1 - order.fee));
}

export function cryptoToFiat(order: { rate: number; fee: number }, value: null | number): number {
  return (value ?? 0) / (order.rate * (1 - order.fee));
}
